<template>
  <enterprises-table
    :api-u-r-l="apiURL"
    :title="name"
  >
    <template v-slot:back>
      <back-button />
    </template>
    <template v-slot:button>
      <v-btn
        color="blue darken-1"
        dark
        class="mb-2"
        @click="associate()"
      >
        Nueva Empresa
      </v-btn>
    </template>
  </enterprises-table>
</template>

<script>
  import EnterprisesTable from '~/components/EnterprisesTable';
  import BackButton from '~/components/BackButton';

  export default {
    middleware: 'auth',
    components: {
      EnterprisesTable,
      BackButton,
    },
    props: {
      dealerId: { default: '' },
    },
    data: () => ({
      name: '',
    }),
    computed: {
      apiURL() {
        return `/api/catalogs/dealers/${this.dealerId}/enterprises`;
      },
    },
    mounted() {
      window.axios.get(`/api/catalogs/dealers/${this.dealerId}`)
      .then((result) => {
        this.name = `Empresas de <b>${result.data.razonSocial} - ${result.data.identificacion}</b>`;
      });
    },
    methods: {
      associate() {
        this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
      },
    },
  };
</script>
